const list = {
    'BTCUSDT': 'بیت کوین',
    'ETHUSDT': 'اتریوم',
    'BNBUSDT': 'بایننس کوین',
    'BCCUSDT': 'بیت کوین کش',
    'NEOUSDT': 'نئو',
    'LTCUSDT': 'لایت کوین',
    'QTUMUSDT': 'کوانتوم',
    'ADAUSDT': 'کاردانو',
    'XRPUSDT': 'ریپل',
    'EOSUSDT': 'ایاس',
    'TUSDUSDT': 'ترو یو اس دی',
    'IOTAUSDT': 'آیوتا',
    'XLMUSDT': 'استلار',
    'ONTUSDT': 'آنتولوژی',
    'TRXUSDT': 'ترون',
    'ETCUSDT': 'اتریوم کلایک',
    'ICXUSDT': 'آیکون',
    'VENUSDT': 'ویچین',
    'NULSUSDT': 'نالز',
    'VETUSDT': 'وی چین',
    'PAXUSDT': 'پکسوز',
    'BCHABCUSDT': '22',
    'BCHSVUSDT': '23',
    'USDCUSDT': 'یو اس دی کوین',
    'LINKUSDT': 'چین لینک',
    'WAVESUSDT': 'ویوز',
    'BTTUSDT': 'بیت تورنت',
    'USDSUSDT': 'استیبل',
    'ONGUSDT': 'آنتولوژی گز',
    'HOTUSDT': 'هولو',
    'ZILUSDT': 'زیلیکا',
    'ZRXUSDT': 'زیرو اکس',
    'FETUSDT': 'فچ',
    'BATUSDT': 'بیسیک اتنشن',
    'XMRUSDT': 'مونرو',
    'ZECUSDT': 'زی کش',
    'IOSTUSDT': 'آی او اس تی',
    'CELRUSDT': 'سلر نتورک',
    'DASHUSDT': 'دش',
    'NANOUSDT': 'نانو',
    'OMGUSDT': 'اومیسی گو',
    'THETAUSDT': 'تتا',
    'ENJUSDT': 'انجین کوین',
    'MITHUSDT': 'میتریل',
    'MATICUSDT': 'متیک',
    'ATOMUSDT': 'کاسموس',
    'TFUELUSDT': 'تتا فیول',
    'ONEUSDT': 'هارمونی',
    'FTMUSDT': 'فانتوم',
    'ALGOUSDT': 'الگوراند',
    'USDSBUSDT': 'استیبل',
    'GTOUSDT': 'گیفتو',
    'ERDUSDT': 'الراند',
    'DOGEUSDT': 'دوج کوین',
    'DUSKUSDT': 'داسک',
    'ANKRUSDT': 'انکر نتورک',
    'WINUSDT': 'وینک',
    'COSUSDT': 'کانتنت اواس',
    'NPXSUSDT': '',
    'COCOSUSDT': 'کوکوس',
    'MTLUSDT': 'متال',
    'TOMOUSDT': 'توموچین',
    'PERLUSDT': 'پرلین',
    'DENTUSDT': 'دنت',
    'MFTUSDT': 'مین فریم',
    'KEYUSDT': 'سلف کی',
    'STORMUSDT': 'استورم',
    'DOCKUSDT': 'داک',
    'WANUSDT': 'ون چین',
    'FUNUSDT': 'فان فیر',
    'CVCUSDT': 'سیویک',
    'CHZUSDT': 'چیلیر',
    'BANDUSDT': 'باند پروتکل',
    'BUSDUSDT': 'بایننس یو اس دی',
    'BEAMUSDT': 'بیم',
    'XTZUSDT': 'تزوس',
    'RENUSDT': 'ریپابلبک توکن',
    'RVNUSDT': 'ریون کوین',
    'HCUSDT': 'هایپر کش',
    'HBARUSDT': 'هدرا هشگراف',
    'NKNUSDT': 'ان کی ان',
    'STXUSDT': 'بلک استک',
    'KAVAUSDT': 'کاوا',
    'ARPAUSDT': 'آرپاچین',
    'IOTXUSDT': 'آیوتکس',
    'RLCUSDT': 'آی اکسز آر ال سی',
    'MCOUSDT': 'ام سی او',
    'CTXCUSDT': 'کورتکس',
    'BCHUSDT': 'بیت کوین کش',
    'TROYUSDT': 'تروی',
    'VITEUSDT': 'وایت',
    'FTTUSDT': 'اف تی ایکس',
    'EURUSDT': '',
    'OGNUSDT': 'اوریجین توکن',
    'DREPUSDT': 'دی رپ',
    'BULLUSDT': '',
    'BEARUSDT': '',
    'ETHBULLUSDT': '',
    'ETHBEARUSDT': '',
    'TCTUSDT': 'توکن کلاب',
    'WRXUSDT': 'وزیر ایکس',
    'BTSUSDT': 'بیت شرز',
    'LSKUSDT': 'لیسک',
    'BNTUSDT': 'بانکور',
    'LTOUSDT': 'ال تی او نتورک',
    'EOSBULLUSDT': '1',
    'EOSBEARUSDT': '1',
    'XRPBULLUSDT': '1',
    'XRPBEARUSDT': '1',
    'STRATUSDT': 'استراتیس',
    'AIONUSDT': 'آئون',
    'MBLUSDT': 'مووی بلاک',
    'COTIUSDT': 'کوتی',
    'BNBBULLUSDT': '1',
    'BNBBEARUSDT': '1',
    'STPTUSDT': 'اس تی پی نتورک',
    'WTCUSDT': 'والتون',
    'DATAUSDT': 'استریمر داتاکوین',
    'XZCUSDT': 'فیرو',
    'SOLUSDT': 'سولانا',
    'CTSIUSDT': 'کارتزی',
    'HIVEUSDT': 'هایو',
    'CHRUSDT': 'کرومیا',
    'BTCUPUSDT': '1',
    'BTCDOWNUSDT': '1',
    'GXSUSDT': 'جی ایکس چین',
    'ARDRUSDT': 'آردور',
    'LENDUSDT': 'آوی',
    'MDTUSDT': 'مژربل دیتا توکن',
    'STMXUSDT': 'استورم ایکس',
    'KNCUSDT': 'کایبر نتورک',
    'REPUSDT': 'آگور ورژن2',
    'LRCUSDT': 'لوپرینک',
    'PNTUSDT': 'پنتا',
    'COMPUSDT': 'کامپوند',
    'BKRWUSDT': '1',
    'SCUSDT': 'سیا کوین',
    'ZENUSDT': 'هایریزن',
    'SNXUSDT': 'سینتیکس',
    'ETHUPUSDT': '1',
    'ETHDOWNUSDT': '1',
    'ADAUPUSDT': '1',
    'ADADOWNUSDT': '1',
    'LINKUPUSDT': '1',
    'LINKDOWNUSDT': '1',
    'VTHOUSDT': 'وتور',
    'DGBUSDT': 'دیجی بایت',
    'GBPUSDT': '1',
    'SXPUSDT': 'سوایپ',
    'MKRUSDT': 'میکر',
    'DAIUSDT': '1',
    'DCRUSDT': 'دکرد',
    'STORJUSDT': 'استورج',
    'BNBUPUSDT': '1',
    'BNBDOWNUSDT': '1',
    'XTZUPUSDT': '1',
    'XTZDOWNUSDT': '1',
    'MANAUSDT': 'دی سنترلند',
    'AUDUSDT': '1',
    'YFIUSDT': 'یرن فایننس',
    'BALUSDT': 'بالانسر',
    'BLZUSDT': 'بلوزل',
    'IRISUSDT': 'آی آر اس نت',
    'KMDUSDT': 'کمودو',
    'JSTUSDT': 'جاست',
    'ANTUSDT': 'آراگون',
    'SRMUSDT': 'سروم',
    'CRVUSDT': 'کرو',
    'SANDUSDT': 'سندباکس',
    'OCEANUSDT': 'اوشن پروتکل',
    'NMRUSDT': 'نوموریر',
    'DOTUSDT': 'پولکادات',
    'LUNAUSDT': 'ترا',
    'RSRUSDT': 'ریزرو رایتس',
    'PAXGUSDT': 'پکس گلد',
    'WNXMUSDT': 'ریپد ان ایکس ام',
    'TRBUSDT': 'تلور',
    'BZRXUSDT': 'بی زد ایکس پروتکل',
    'SUSHIUSDT': 'سوشی',
    'YFIIUSDT': 'دی اف ای مانی',
    'KSMUSDT': 'کوساما',
    'EGLDUSDT': 'الراند گلد',
    'DIAUSDT': 'دیا',
    'RUNEUSDT': 'تورچین',
    'FIOUSDT': 'اف آی او پروتکل',
    'UMAUSDT': 'یو ام ای',
    'EOSUPUSDT': '1',
    'EOSDOWNUSDT': '1',
    'TRXUPUSDT': '1',
    'TRXDOWNUSDT': '1',
    'XRPUPUSDT': '1',
    'XRPDOWNUSDT': '1',
    'DOTUPUSDT': '1',
    'DOTDOWNUSDT': '1',
    'BELUSDT': 'بلا پروتکل',
    'WINGUSDT': 'وینگ پروتکل',
    'LTCUPUSDT': '1',
    'LTCDOWNUSDT': '1',
    'UNIUSDT': 'یونی سواپ',
    'NBSUSDT': 'نیو بیت شرز',
    'OXTUSDT': 'ارکید',
    'SUNUSDT': 'سان',
    'AVAXUSDT': 'آولنج',
    'HNTUSDT': 'هلیوم',
    'FLMUSDT': 'فلامینگو',
    'UNIUPUSDT': '1',
    'UNIDOWNUSDT': '1',
    'ORNUSDT': 'اوریون پروتکل',
    'UTKUSDT': 'یوتراست',
    'XVSUSDT': 'ونوس',
    'ALPHAUSDT': 'آلفا فایننس لب',
    'AAVEUSDT': 'آوی',
    'NEARUSDT': 'نیر پروتکل',
    'SXPUPUSDT': '1',
    'SXPDOWNUSDT': '1',
    'FILUSDT': 'فایل کوین',
    'FILUPUSDT': '1',
    'FILDOWNUSDT': '1',
    'YFIUPUSDT': '1',
    'YFIDOWNUSDT': '1',
    'INJUSDT': 'اینجکتیو پروتکل',
    'AUDIOUSDT': 'آدیوس',
    'CTKUSDT': 'سرتیک',
    'BCHUPUSDT': '1',
    'BCHDOWNUSDT': '1',
    'AKROUSDT': 'آکروپلیس',
    'AXSUSDT': 'آکسی اینفینیتی',
    'HARDUSDT': 'هارد پروتکل',
    'DNTUSDT': 'دیستریکت زیرو ایکس',
    'STRAXUSDT': 'استراتیس',
    'UNFIUSDT': 'یونیفای پروتکل',
    'ROSEUSDT': 'یو آیسیس نتورک',
    'AVAUSDT': 'تراولا',
    'XEMUSDT': 'نم',
    'AAVEUPUSDT': '',
    'AAVEDOWNUSDT': '',
    'SKLUSDT': 'اسکیل نتورک',
    'SUSDUSDT': 'اس یو اس دی',
    'SUSHIUPUSDT': '',
    'SUSHIDOWNUSDT': '',
    'XLMUPUSDT': '',
    'XLMDOWNUSDT': '',
    'GRTUSDT': 'گراف توکن',
    'JUVUSDT': 'یونتوی فن توکن',
    'PSGUSDT': 'پاری سن ژرمن',
    '1INCHUSDT': '1 اینج',
    'REEFUSDT': 'ریف فایننس',
    'OGUSDT': 'او جی فن توکن',
    'ATMUSDT': 'اتلتیکو مادرید فن توکن',
    'ASRUSDT': 'آ.اس روم فن توکن',
    'CELOUSDT': 'سلو',
    'RIFUSDT': 'آر اس کا اینفراستراکچر',
    'BTCSTUSDT': 'بیت کوین هش ریت توکن',
    'TRUUSDT': 'تروفای',
    'CKBUSDT': '',
    'TWTUSDT': 'تراست ولت توکن',
    'FIROUSDT': 'فیرو',
    'LITUSDT': 'لایت توکن',
    'SFPUSDT': 'سیف پل',
    'DODOUSDT': 'دودو',
    'CAKEUSDT': 'پنکیک سواپ',
    'ACMUSDT': '',
    'BADGERUSDT': 'بجر دائو',
    'FISUSDT': 'استفی',
    'OMUSDT': '',
    'PONDUSDT': '',
    'DEGOUSDT': '',
    'ALICEUSDT': 'مای نیبرآلیس',
    'LINAUSDT': 'لینیر',
    'PERPUSDT': '',
    'RAMPUSDT': '',
    'SUPERUSDT': 'سوپرفارم',
    'CFXUSDT': 'کانفلاکس نتورک',
    'EPSUSDT': 'الیپسیس',
    'AUTOUSDT': '',
    'TKOUSDT': 'توکوکریپتو',
    'PUNDIXUSDT': 'پاندی ایکس',
    'TLMUSDT': 'آلین ورلدز',
    '1INCHUPUSDT': '',
    '1INCHDOWNUSDT': '',
    'BTGUSDT': '',
    'MIRUSDT': '',
    'BARUSDT': '',
    'FORTHUSDT': '',
    'BAKEUSDT': 'بیکری',
    'BURGERUSDT': '',
    'SLPUSDT': '',
    'SHIBUSDT': 'شیبا',
    '1000SHIBUSDT': 'شیبا',
    'ICPUSDT': '',
    'ARUSDT': 'آرویو',
    'POLSUSDT': 'پولکا استارتر',
    'MDXUSDT': '',
    'MASKUSDT': '',
    'LPTUSDT': '',
    'BTCDOMUSDT': 'بیت کوین دام',
    'GTCUSDT': 'گیتکوین',
    'DEFIUSDT': 'دیفای',
};

export default list;